// @flow
// fc-auth
import reducer from 'hfty-auth/src/reducer'
import initialState from 'hfty-auth/src/initialState'

// Utils
import createReducer from 'fc-utils/createReducer'

export default createReducer(initialState, reducer)
